import { DestinationAssignmentProps } from '../types';
import { DestinationAssignmentOption } from './Conversion.types';

const sortByLabel = (
  prev: DestinationAssignmentOption,
  next: DestinationAssignmentOption
) => {
  return prev.label.localeCompare(next.label);
};

const filterDestinationAssignmentsForConversion = (
  assignments: DestinationAssignmentProps[],
  currentAssignment: DestinationAssignmentProps
): DestinationAssignmentOption[] => {
  return assignments
    .filter(
      (assignment: DestinationAssignmentProps) =>
        assignment.provider === currentAssignment.provider &&
        assignment.gradeType === currentAssignment.gradeType &&
        assignment.isAnonymised === currentAssignment.isAnonymised &&
        assignment.groupSet === currentAssignment.groupSet &&
        assignment.id !== currentAssignment.id
    )
    .map(({ id, title }) => ({
      key: id,
      value: id,
      label: title,
    }))
    .sort(sortByLabel);
};

export default filterDestinationAssignmentsForConversion;
